<template lang="pug">
//- ******************** GENERAL INFORMATION ********************//
section#requester-information
  v-layout(justify-center)
    v-flex(xs8)
      v-card-title(primary-title)
        h1.main-title.sec General Information
    v-flex(xs12, md4, lg3)
      v-text-field(
        :disabled="true",
        v-model="$store.state.Group.selected.name",
        label="Business Scope"
      )
  //- v-layout(justify-center)
    v-flex(xs12, md4, lg3)
    v-flex(xs12, md4, lg3)
  v-layout(justify-center)
    v-flex(xs12, md4, lg3)
      v-text-field(v-model="$$me().name", :disabled="true", label='Requester Name')
    v-flex(xs11='', md4, lg3)
      v-text-field(v-model="$$me().lastName", :disabled="true", label='Requester Last Name')
    v-flex(xs12, md4, lg3)
      v-text-field(v-model="$$me().eMail", :disabled="true", label='Requester Mail')
  v-layout(justify-center)
    v-flex(xs12, md4, lg3)
      v-autocomplete(
        :items="$store.state.Party.list.concat({ name: 'New Party' })",
        label="Select Buyer",
        item-text="name",
        return-object,
      )
    v-flex(xs12, md4, lg3)
    v-flex(xs12, md4, lg3)
      v-autocomplete(
        :items="$store.state.Party.list.concat({ name: 'New Party' })",
        label="Select Seller",
        item-text="name",
        return-object,
      )
  v-layout(justify-center)
    v-flex(v-for="(reference, index) in references", xs12, md4, lg3)
      v-text-field(
        v-model="references[0]",
        :label='`Reference ${index + 1}`'
      )
  //- ******************** REQUESTER INFORMATION ********************//
  //- v-layout(justify-center)
    v-flex(xs12)
      v-card-title(primary-title)
        h1.main-title.sec Requester Information
</template>

<script>

export default {
  /**
   * An alternative to string templates allowing you to
   * leverage the full programmatic power of JavaScript.
   * The render function receives a createElement method
   * as it’s first argument used to create VNodes.
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/#render}
   * @member {Object<mixed>}
   * @memberOf OrderGeneralSection
   */
  // render: h => h(App),

  /**
   * The data object for the Vue instance.
   * Vue will recursively convert its properties
   * into getter/setters to make it “reactive”
   * and these methods directly via "this".
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/#data}
   * @member {Object<mixed>}
   * @memberOf OrderGeneralSection
   */
  data: function () {
    return {
      references: [
        '',
        '',
        ''
      ]
    }
  },

  /*
   * Computed properties to be mixed into the Vue instance.
   * All getters and setters have their this context
   * automatically bound to the Vue instance.
   * Note that if you use an arrow function with a computed property,
   * this won’t be the component’s instance
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/?#computed}
   * @member {Object<mixed>}
   * @memberOf OrderGeneralSection
   */
  computed: {
    //
  },

  /*
   * An object where keys are expressions to watch and values
   * are the corresponding callbacks. The value can also be
   * a string of a method name, or an Object that contains
   * additional options. The Vue instance will call $watch()
   * for each entry in the object at instantiation.
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/?#watch}
   * @member {Object<mixed>}
   * @memberOf OrderGeneralSection
  */
  watch: {

  },

  /**
   * Methods to be mixed into the Vue instance.
   * You can access these methods directly via "this"
   * there are bound to the Vue instance.
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/#methods}
   * @member {Object<function>}
   * @memberOf OrderGeneralSection
   */
  methods: {
    //
  },

  /**
   * Called after the instance has been mounted,
   * where el is replaced by the newly created vm.$el.
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/#mounted}
   * {@link https://vuejs.org/v2/api/#Options-Lifecycle-Hooks}
   * @memberOf OrderGeneralSection
   */
  mounted () {
    //
  }
}
</script>